import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../../helpers/constants';
import { callApi } from '../../../helpers/methods';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getToken, isAuthenticated } from '../../../store/auth';

//COMPONENTS
import { Row, Column, IBox, Button, Return, Select } from '../../inspinia';
import ModalPreview from '../../campanha/modalPreview';
import ModalSendTest from '../../campanha/modalSendTest';
import RichTextEditor from '../../richtext';
import { templateAction } from '../../../store/template';
import { campanhaAction } from '../../../store/campanha';
import TemplateList from '../listaTemplate/index';
import TagCarimbo from '../tagCarimbo';

class TemplateCarimbo extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            modalPreviewIsOpen: false,
            modalSendTestIsOpen: false,
            templates: [],
            tags: [],
            comboEmpresa:
            {
                results: undefined
            },
            status: "criar",
            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,
            posicaomouse1: [],
            posicaomouse2: [],
            tipoSalvar: "",
            templateAntigo: "",
            hiddenEditor: true,

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }
        this.handleChangeCompany = this.handleChangeCompany.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
        this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
        this.handleTestToggle = this.handleTestToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.click = this.click.bind(this);
        this.insereTemplate = this.insereTemplate.bind(this);
        this.onClickCancelar = this.onClickCancelar.bind(this);
        this.handleNovoTemplate = this.handleNovoTemplate.bind(this);
        this.LoadTemplates = this.LoadTemplates.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    formInitialState() {
        return {
            id: "",
            template: [],
            campanha: {},
            file: ""
        }
    }

    componentDidMount() {
        this.LoadTemplates();
    }


    insereTemplate(states, id, comp) {

        let self = this;
        comp.preventDefault();

        const url = `${c.API_BASE_URL}/template-carimbo-tempo/${id}`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, function (response) {
            self.setState({ ...self.state, form: response, hiddenEditor: false, status: "atualizar" });
        });
    }

    LoadTemplates() {
        let self = this;

        const url = `${c.API_BASE_URL}/template-carimbo-tempo`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, templates: response });
        });
    }

    LoadTags() {
        let self = this;

        const url = `${c.API_BASE_URL}/template-carimbo-tempo/tags/all`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, tags: response });
        })
    }

    handlePreviewToggle(e) {
        this.setState({ ...this.state, modalPreviewIsOpen: !this.state.modalPreviewIsOpen });
    }

    handleTestToggle(e) {
        this.setState({ ...this.state, modalSendTestIsOpen: !this.state.modalSendTestIsOpen });
    }

    handleSave(e) {
        e.preventDefault(); 
        
        if (this.state.loading) return;

        this.state.form.auth = this.state.auth;

        this.props.actions.template.salvarTemplateCarimbo(this.state.form, this.state.status).then((response) => {
            
            if (response.status === "BAD_REQUEST") {
                c.TOASTER_SUCCESS(response.message);
                return;
            }
            if (response) {
                window.location.reload();
                c.TOASTER_SUCCESS("Template salvo com sucesso!");
            }

        }).catch((error) => {
             if(error.message) {
                if(error.status === "UNAUTHORIZED"){
                    c.TOASTER_ERROR(c.UNAUTHORIZED_ERROR); 
                }else if(error.message === "id inválido"){
                    c.TOASTER_ERROR("O campo Empresa é obrigatório.");
                }else if(error.message === "Unexpected end of JSON input"){
                    c.TOASTER_ERROR("O nome do template já está sendo usado.");
                }else{
                    c.TOASTER_ERROR(error.message);
                }
            }else {
                c.TOASTER_ERROR(c.NETWORK_ERROR);
            };
        });
    }

    click(campo) {
        var startPos = campo.target.selectionStart;
        var endPos = campo.target.selectionEnd;
        this.setState({posicaomouse1: startPos, posicaomouse2: endPos });
    }

    handleChangeCompany(e) {
        const valor = e.target.value === "Selecione..." ? 0 : e.target.value;
        const form = this.state.form;
        this.setState({ form: { ...form, [e.target.name]: {id: e.target.value }} });
    }

    handleChangeText = (content) => {
                const texto = content.replace("tagselectorhtml:", "");
                this.setState(prev => ({
                    form: {
                        ...prev.form,
                        mensagem: texto
                    }
                }));
            }

    handleChangeTextHtml(textFromHTML) {
        textFromHTML = textFromHTML.replace("tagselectorhtml:", "");
        let lastConteudo = this.state.form.mensagem ? `${this.state.form.mensagem}\n` : "";
        let novoConteudo = `${lastConteudo}${textFromHTML}`;
        this.state.form.mensagem =  novoConteudo;
        this.setState({ posicaomouse1: 0, posicaomouse2: 0 });
    }

    onChangeFile(e) {
        const form = this.state.form;

        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (this.state.form.file !== '') {

            if (!isAuthenticated()) {
                throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
            }

            const _token = c.AUTH_HEADER(getToken());
            let data = new FormData();
            data.append('file', form.file);
            const url = `${c.API_CAMPAIGN_URL}/uploadFileHtml`;
            const options = {
                method: 'POST',
                body: data,
                headers: { 'Authorization': _token }
            };

            fetch(url, options).then(async (response) => {
                let json = await response.json();

                if (response.ok) {
                    this.handleChangeTextHtml(json.html);

                } else {
                    c.TOASTER_ERROR(json.message);

                }
            }).catch((exception) => {
                console.log("fetch error" + exception);
            });

        }

    }

    onClickCancelar() {
        this.setState({
            ...this.state,
            form: {
                mensagem: "",
                id: "",
                template: [],
                file: ""
            },
            hiddenEditor: true,
            removeAnexo: true
        });
    }

    handleNovoTemplate() {
        this.setState({ ...this.state, hiddenEditor: false });
    }

    render() {
        const form = this.state.form;

        return (
            <div>
                <ModalPreview isOpen={this.state.modalPreviewIsOpen} toggle={this.handlePreviewToggle} preview={form.mensagem} />
                <ModalSendTest isOpen={this.state.modalSendTestIsOpen} toggle={this.handleTestToggle} />

                {/* {Lista de templates} */}
                <div hidden={!this.state.hiddenEditor}>
                    <Row className="mb-3">
                        <Column size="12">
                            <TemplateList
                                status={this.state}
                                templates={this.state.templates}
                                onClick={this.insereTemplate}
                                novoTemplate={this.handleNovoTemplate}
                                history={this}
                                recarregar={true}
                            />
                        </Column>
                    </Row>
                </div>

                {/* { Editor HTML } */}
                <div hidden={this.state.hiddenEditor}>
                    {/* TITLE */}
                    <Row className="mb-4">
                        <Column size="3">
                            <h2 className="fs-20 fw-600 text-body m-0">Editor HTML</h2>
                        </Column>

                        <Column size="9">
                            <div className="input-group d-block fs-14 text-right">
                                <button type="button" onClick={this.handlePreviewToggle} className="btn btn-link px-3">Pré-visualizar</button>
                                <button name="salvar" onClick={this.handleSave} type="button" className="btn btn-link px-3">Salvar</button>
                            </div>
                        </Column>
                    </Row>

                    {/* FORM */}
                    <Row className="mb-3">
                        <Column size="9">
                            <IBox className="mb-0">
                                <div>
                                    <label>Nome do Template</label>
                                </div>
                                    <label className="fs-20 fw-600 text-body m-0">{this.state.form.campanha.descricao}</label>
                                <div>
                                    
                                </div>
                                
                                <div className='mt-3'>
                                    <label>Selecione o Arquivo HTML</label>
                                </div>

                                <div>
                                    <input type="file" name="file"
                                        id="validatedCustomFile"
                                        required
                                        value={this.state.arquivo}
                                        onChange={this.onChangeFile}
                                        onClick={(event) => event.target.value = null}
                                    />

                                </div>
                                
                                

                                <label className='mt-3'>Corpo do Template</label>

                                {/* Editor here */}
                                <RichTextEditor id="summernote" key={this.state.form.id || 'new'} value={this.state.form.mensagem} onChange={this.handleChangeText} onClick={this.click} />
                            </IBox>
                        </Column>
                        <Column size="3" className="container">
                            <Row>
                                <Column size="12">
                                    <TagCarimbo />
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                    <Row>
                        <Column size="3">
                            <Return to="/carimbo/templates" width="130px" />
                        </Column>
                    </Row>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, template: state.template, arquivo: state.campanha };
}

function mapDispatchToProps(dispatch) {
    return { actions: { template: bindActionCreators(templateAction, dispatch), arquivo: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplateCarimbo));
